enum BenefitUtilizationStatus {
  Attested = 'Attested (Annual)',
  PremiumSubmitted = 'Premium submitted',
  PremiumVerified = 'Premium verified',
  PremiumReimbursed = 'Premium reimbursed',
}

export default BenefitUtilizationStatus
